import Button from "../../../components/Button";
import Layout from "../../../components/Layout";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useStyles from "../styles";
import { Icon } from "@iconify/react/dist/iconify.js";
import {
  Grid,
  useMediaQuery,
  useTheme
} from "@mui/material";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import InputGroup from "../../../components/FormComponent/InputGroup";
import Modal from "../../../components/Modal";
import PageTitle from "../../../components/PageTitle";
import { httprequest } from "../../../data/api";
import TermReportTemplate from "../component/TermReportTemplate";
import TabContext from "@mui/lab/TabContext";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import SessionReportTemplate from "../component/SessionReportTemplate";

const EXTRAS_ENDPOINT = "/api/v1/school-extras";

const ReportTemplate = () => {
  const classes = useStyles();
  const theme = useTheme();
  const [titles, setTitles] = useState([{ id: 1, value: "" }]);
  const [extraData, setExtrasData] = useState([]);
  const [value, setValue] = useState("1");
  const isMobile = useMediaQuery(theme.breakpoints.down(1200));
  const [sectionModal, setSectionModal] = useState(false);
  const [templateModal, setTemplateModal] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewTemplate, setPreviewTemplate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSectionModal = () => {
    setSectionModal(!sectionModal);
  };
  const addTitleField = () => {
    setTitles([...titles, { id: Date.now(), value: "" }]);
  };

  const handleTemplateModal = () => {
    setTemplateModal(!templateModal);
  };

  const handlePreviewModal = (template = null) => {
    setPreviewTemplate(template);
    setPreviewModal(!previewModal);
    setTemplateModal(false);
  };

  const handleTemplateSelect = async (template) => {
    if (!template || template.locked) return;

    setIsLoading(true);
    try {
      const templateData = {
        report_template: {
          template_id: template.id,
          version: template.version
        }
      };

      const response = await httprequest.patch("/api/v1/profile", templateData);
      toast.success(response?.data?.message || "Template updated successfully");
      setTimeout(() => {
        window.location.reload();
      }, 1500);
      handlePreviewModal(); // Close preview modal
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to update template");
    } finally {
      setIsLoading(false);
    }
  };

  const removeTitleField = (id) => {
    if (titles.length > 1) {
      setTitles(titles.filter(title => title.id !== id));
    }
  };

  const handleTitleChange = (id, value) => {
    setTitles(titles.map(title => title.id === id ? { ...title, value } : title
    ));
  };

  const getAllExtras = () => {
    httprequest
      .get(EXTRAS_ENDPOINT)
      .then((res) => {
        setExtrasData(res.data.data);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  useEffect(() => {
    getAllExtras();
  }, []);

  return (
    <Layout children={
      <>
        <PageTitle
          title="Report Template"
          subtitle="Manage report template here."
          button={
            isMobile && (
              <Button
                variant="primary"
                buttonSize="fluid"
                color="btndefault"
                buttonName="Select Template"
                buttonIcon={<Icon icon="prime:check-circle" width="24" height="24" />}
                onClick={handleTemplateModal}
              />
            )
          }

        />

        <TabContext value={value}>
          <div className="tablist-container">
            <Tabs className="overide-tablist" onChange={handleChange} aria-label="">
              <Tab label="Term Template" value="1" />
              <Tab label="Session Template" value="2" />
            </Tabs>
          </div>
          <div>
            <TabPanel value="1" className="tabpanel-overide">
              <TermReportTemplate extraData={extraData} templateModal={templateModal} handleTemplateModal={handleTemplateModal} isMobile={isMobile}
                onTemplateSelect={handleTemplateSelect}
                onTemplatePreview={handlePreviewModal}
                setTemplateModal={setTemplateModal}
              />
            </TabPanel>
            <TabPanel value="2" className="tabpanel-overide">
              <SessionReportTemplate extra={extraData}
                templateModal={templateModal} handleTemplateModal={handleTemplateModal} isMobile={isMobile}
                onTemplateSelect={handleTemplateSelect}
                onTemplatePreview={handlePreviewModal}
                setTemplateModal={setTemplateModal}
              />
            </TabPanel>
          </div>
        </TabContext>
        <Modal
          title="Add New Section"
          subtitle={<div>Create a new section to be added to the report.</div>}
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Section Name"
                    margin="normal"
                    placeHolder="Name"
                    inputType="text"
                  />
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Section Type"
                    children={
                      <select>
                        <option value="">--- Select ---</option>
                        <option value="score">Score</option>
                        <option value="grade">Grade</option>
                        <option value="text">Text/Note</option>
                      </select>
                    }
                  />
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <p className="label-tag">Title</p>
                  {titles.map((title) => (
                    <div key={title.id} className={classes.titlediv}>
                      <input
                        type="text"
                        placeholder="Name"
                        value={title.value}
                        onChange={(e) => handleTitleChange(title.id, e.target.value)}
                      />
                      <span onClick={() => removeTitleField(title.id)} style={{ cursor: "pointer" }}>
                        <Icon icon="mingcute:delete-2-line" color="red" />
                      </span>
                    </div>
                  ))}

                </Grid>
                <div onClick={addTitleField}
                  className="flex gap-10 add-another-button"
                ><Icon icon="gg:add" />  Add Another
                </div>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Create Section"
                />
              </div>
            </>
          }
          isopen={sectionModal}
          closeModal={handleSectionModal}
        />

        {/* Template Preview Modal */}
        <Modal
          title={previewTemplate ? `Preview - ${previewTemplate.name}` : "Template Preview"}
          subtitle="Preview of the selected template"
          modalContent={
            previewTemplate && (
              <div className={classes.previewContent}>
                <img
                  src={previewTemplate.image}
                  alt={previewTemplate.name}
                  className={classes.previewTempImage}
                />
                <div className={classes.previewInfo}>
                  <h4>{previewTemplate.name}</h4>
                  <p>Version: {previewTemplate.version}</p>
                  {previewTemplate.locked && (
                    <div className={classes.lockedBadge}>
                      <Icon icon="solar:lock-linear" />
                      <span>Pro Feature</span>
                    </div>
                  )}
                </div>
              </div>
            )
          }
          modalFooter={
            previewTemplate && !previewTemplate.locked && (
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName={isLoading ? "Selecting..." : "Select This Template"}
                  onClick={() => handleTemplateSelect(previewTemplate)}
                  disabled={isLoading}
                />
              </div>
            )
          }
          isopen={previewModal}
          closeModal={handlePreviewModal}
        />

        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default ReportTemplate;
